import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { Http, HttpModule, RequestOptions } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import 'rxjs/Rx';

import { AppComponent } from './app.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';

import { AuthService } from './auth/auth.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { AuthGuardAdminService } from './auth/auth-guard-admin.service';
import { AuthModule } from './auth/auth.module';
import { NgPipesModule } from 'ngx-pipes';
import { MomentModule } from 'angular2-moment';
import { ToastrModule } from 'ngx-toastr';
import { JwtModule } from '@auth0/angular-jwt';
import { SaveGuard } from './order/shared/save.guard.service';
// Routing Module
import { AppRoutingModule } from './app.routing';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

// Modules
import { SharedModule } from './shared/shared.module';

import { SharedService } from './shared/shared.service';
import { OrderService } from './order/shared/order.service';

import { SlogModulesModule } from 'ngx-slog';
import { NoentryComponent } from './noentry/noentry.component';
import { SettingsService } from 'app/settings/settings.service';

import { ProductsComponent } from './products/products.component'

export function tokenGetter(): string {
    return localStorage.getItem('access_token');
}

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        AccordionModule.forRoot(),
        CollapseModule.forRoot(),
        ChartsModule,
        HttpModule,
        SharedModule,
        AuthModule,
        BrowserAnimationsModule,
        NgPipesModule,
        MomentModule,
        FormsModule,
        ToastrModule.forRoot(),
        HttpClientModule,
        SharedModule.forRoot(),
        JwtModule.forRoot({
            config: {
                tokenGetter,
                whitelistedDomains: [
                    'localhost:446',
                    'ebapi.dockerdev.slog.no',
                    'eidsiva-api.slog.no',
                    'eidsiva-test-api.dockerdev.slog.no',
                    'docker.slog.no:448',
                    'gkedev.slog.no/eidsiva/portal'
                ]
            }
        }),
        SlogModulesModule.forRoot()
    ],
    declarations: [
        AppComponent,
        FullLayoutComponent,
        SimpleLayoutComponent,
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        NoentryComponent,
        ProductsComponent
    ],
    providers: [AuthGuardService, SaveGuard, AuthGuardAdminService, AuthService, SharedService, OrderService, SettingsService],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts